
import apiHelpers from './apiHelpers.js';
import { mapCrudStoreGen } from '@/helpers/utils/storeHelpers.js';

let defaultForm = {
  id: null,
  status: 'active',
  type: 'Stock Item',
  factoringPercentage: 0,
  wholesalePrice: 0,
  description: '',
  inventoryStatus: 0,
  trackSerialNumber: 0,
  trackExpirationDate : 1,
  trackLotNumber: 1,
  trackCost: 1,
  weight: 0,
  vendorId: '',
  warehouseId: '',
  itemUnit: 'E',
  item: '',
  primaryUom: 'Each',
  packagingUom: 'Each',
  packagingUnitNumOfUnits: 1,
  packagingUnitHeight: 0,
  packagingUnitLength: 0,
  packagingUnitWidth: 0,
  movableUnitNumOfUnits: null,
  movableUnitWeight: 0,
  movableUnitHeight: 0,
  movableUnitLength: 0,
  movableUnitWidth: 0
};

let defaultFilters = {
  showToReview: false,
  status: null,
  brandId: '',
  type: null,
  sku: '',
  name: ''
};

let genedStore = mapCrudStoreGen(defaultForm, defaultFilters, apiHelpers);

let ItemModule = {
  namespaced: true,

  state: () => ({
    ...genedStore.state
  }),

  mutations: {
    ...genedStore.mutations
  },

  getters: {
    ...genedStore.getters
  },

  actions: {
    ...genedStore.actions
  }
};

export default ItemModule;
